<template>
  <sc-card :title="title" secondFooter v-if="type === `widget`">
    <div class="sc-chart-widget">
      <div class="sc-chart-widget__controls-title">
        <r-text type="caption">
          {{ $t("period") }}
        </r-text>
      </div>
      <ul class="sc-chart-widget__controls">
        <li
          :class="[
            `sc-chart-widget__controls-item`,
            { active: dataStep === item }
          ]"
          v-for="item in controlsItem"
          :key="item"
          @click="changeDataStep(item)"
        >
          <r-text type="caption">
            {{ $t(item) }}
          </r-text>
        </li>
      </ul>
    </div>
    <sc-charts-builder
      v-if="chartData"
      :chart-data="chartData"
      :title="title"
      :type="chartType"
      :changeChartType="changeChartType"
      slot="second-footer"
    />
  </sc-card>
  <scChartModalWindow v-bind="$props" v-else />
</template>

<script>
import moment from "moment";
import scCard from "../../layout/card";
import scChartsBuilder from "./components/charts/charts";
import scChartModalWindow from "./components/modal-window/modal-window";
import { prepareChartData, historyRequest } from "./components/charts/helpers";

const controlsItem = ["hour", "day", "week", "month"];
const chartTypes = ["type-1", "type-2", "type-3"];

export default {
  props: {
    type: {
      type: String,
      default: "widget"
    },
    url: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ""
    }
  },
  components: { scCard, scChartsBuilder, scChartModalWindow },
  data() {
    return {
      dataStep: "day",
      chartType: "type-1",
      chartData: null,
      chartTypes,
      controlsItem
    };
  },
  watch: {
    currentHistoryConfig() {
      this.getChartData();
    }
  },
  computed: {
    currentHistoryConfig() {
      const to = moment(new Date())
        .zone(0)
        .format();
      const from =
        this.dataStep === "hour"
          ? moment(new Date())
              .zone(0)
              .subtract(2, this.dataStep)
              .format()
          : moment(new Date())
              .zone(0)
              .subtract(1, this.dataStep)
              .format();
      let step;
      switch (this.dataStep) {
        case "hour":
          step = 15;
          break;
        case "day":
          step = 120;
          break;
        case "week":
          step = 540;
          break;
        case "month":
          step = 1600;
          break;
        default:
          break;
      }

      return { from, to, step };
    }
  },
  methods: {
    async getChartData() {
      const data = await historyRequest(this, { url: this.url });
      this.chartData = prepareChartData(data, this.title);
    },
    changeChartType(e) {
      this.chartType = e;
    },
    changeDataStep(val) {
      if (val === this.dataStep) return;

      this.dataStep = val;
    }
  },
  created() {
    this.getChartData();
  }
};
</script>

<style lang="scss">
.sc-chart-widget {
  min-width: 604px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  &__controls-title {
    margin-bottom: 4px;
  }
  &__controls {
    width: 100%;
    display: flex;
    margin-top: -12px;
    margin-bottom: -12px;
    &-item {
      width: 64px;
      height: 32px;
      border: 1px solid;
      display: flex;
      align-items: center;
      justify-content: center;
      border-color: var(--dividers_low_contrast) !important;
      border-right: none;
      cursor: pointer;
      transition: all 0.15s ease;
      &:hover {
        background-color: rgba(var(--accent_primary), 0.5);
        .r-text.caption-2 {
          color: var(--white_white) !important;
        }
      }
      &:active {
        background-color: rgba(var(--accent_primary), 0.8);
        .r-text.caption-2 {
          color: var(--white_white) !important;
        }
      }
      &:first-child {
        border-top-left-radius: var(--border-radius);
        border-bottom-left-radius: var(--border-radius);
      }
      &:last-child {
        border-right: 1px solid;
        border-top-right-radius: var(--border-radius);
        border-bottom-right-radius: var(--border-radius);
      }
      &.active {
        cursor: default;
        background-color: var(--accent_primary);
        border-color: var(--accent_primary) !important;
        .r-text.caption-2 {
          color: var(--white_white) !important;
        }
      }
    }
  }
}
</style>
